import { ApiClient } from './api-client';
import { ConfigState } from 'store/config/types';
import { UserState } from 'store/user/types';

interface ApiClientState {
  user: Pick<UserState, 'token'>;
  config: ConfigState;
}

export const apiClient = (
  state: ApiClientState,
  baseUrlOverride?: string | null,
  authTokenOverride?: string | null,
  buildingUuidOverride?: string | null,
  userBuildingUuidOverride?: string | null,
  localeOverride?: string | null,
): ApiClient => {
  const baseUrl = baseUrlOverride ?? state.config.apiUrl;
  // Prefer config.authToken (from query params) over user.token (from localStorage)
  // to ensure fresh tokens from query params are used over potentially expired localStorage tokens
  const authToken = authTokenOverride ?? state.config.authToken ?? state.user.token;
  const buildingUuid = buildingUuidOverride ?? state.config.buildingUuid;
  const userBuildingUuid = userBuildingUuidOverride ?? state.config.userBuildingUuid;
  const locale = localeOverride ?? (state.config?.locale || navigator?.language || 'en-US');

  return new ApiClient(baseUrl, authToken, buildingUuid, userBuildingUuid, locale);
};
